<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-zip"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l69.2 69.2 69.2 69.2-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0z"
			/>
			<path
				class="duotone"
				d="M.3 27.7C.3 12.4 12.7 0 27.9 0L249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0 0 345.9c0 15.3-12.4 27.7-27.7 27.7L27.9 512C12.7 512 .3 499.6 .3 484.3L.3 27.7zm102 108.7c-7.6 0-13.8 6.2-13.8 13.8l0 68.3c0 7.6 6.2 13.8 13.8 13.8s13.8-6.2 13.8-13.8l0-68.3c0-7.6-6.2-13.8-13.8-13.8zm13.8 136.9c0-7.6-6.2-13.8-13.8-13.8s-13.8 6.2-13.8 13.8l0 68.3c0 7.6 6.2 13.8 13.8 13.8s13.8-6.2 13.8-13.8l0-68.3zm-13.8 109c-15.3 0-27.7 12.4-27.7 27.7l0 41c0 15.3 12.4 27.7 27.7 27.7s27.7-12.4 27.7-27.7l0-41c0-15.3-12.4-27.7-27.7-27.7z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'ZipFileIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #bcc3cf !important;
}
</style>
